import { jsxs, jsx } from "react/jsx-runtime";
import { useEffect, useState, useRef, forwardRef } from "react";
import { a as $e5be200c675c3b3a$export$fc1a364ae1f3ff10, c as $e5be200c675c3b3a$export$a763b9476acd3eb, $ as $458b0a5536c1a7cf$export$40bfa8c7b0832715, d as $e5be200c675c3b3a$export$dad6ae84456c676a } from "../../../../../chunks/useFormValidationState-CYjUuzK3.js";
import { c as clsx } from "../../../../../chunks/clsx-DgYk2OaC.js";
import { useCheckboxGroupProvider } from "./hooks/useCheckboxContext.js";
import { h as helpers } from "../../../../../chunks/helpers.module-CuLQagYQ.js";
import { f as focus } from "../../../../../chunks/FocusRing.module-CN-AOt8Z.js";
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from "../../../../../chunks/useFocusRing-DBUavJAN.js";
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from "../../../../../chunks/mergeProps-bpc4gVdj.js";
import { $ as $99facab73266f662$export$5add1d006293d136, a as $e93e671b31057976$export$b8473d3665f3a75a } from "../../../../../chunks/useFormValidation-CIUJuxeV.js";
import { $ as $f6c31cce2adf654f$export$45712eceda6fad21 } from "../../../../../chunks/usePress-BBilPT3f.js";
import { $ as $65484d02dcb7eb3e$export$457c3d6518dd4c6f } from "../../../../../chunks/filterDOMProps-D2C6R0DK.js";
import { $ as $f645667febf57a63$export$4c014de7c8940b4c } from "../../../../../chunks/useFocusable-Rgl20men.js";
import { $ as $1ae600c947479353$export$ec98120685d4f57d } from "../../../../../chunks/utils-nR0dJhWL.js";
function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
  let { isDisabled = false, isReadOnly = false, value, name, form, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, validationState = "valid", isInvalid, onPressStart, onPressEnd, onPressChange, onPress, onPressUp, onClick } = props;
  let onChange = (e) => {
    e.stopPropagation();
    state.setSelected(e.target.checked);
  };
  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel && process.env.NODE_ENV !== "production") console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    onClick,
    isDisabled
  });
  let { pressProps: labelProps, isPressed: isLabelPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPressUp,
    onClick,
    onPress(e) {
      var _ref_current;
      onPress === null || onPress === void 0 ? void 0 : onPress(e);
      state.toggle();
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    },
    isDisabled: isDisabled || isReadOnly
  });
  let { focusableProps } = $f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  $99facab73266f662$export$5add1d006293d136(ref, state.defaultSelected, state.setSelected);
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: (e) => e.preventDefault()
    }),
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      "aria-invalid": isInvalid || validationState === "invalid" || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-controls": props["aria-controls"],
      "aria-readonly": isReadOnly || void 0,
      onChange,
      disabled: isDisabled,
      ...value == null ? {} : {
        value
      },
      name,
      form,
      type: "checkbox",
      ...interactions
    }),
    isSelected: state.isSelected,
    isPressed: isPressed || isLabelPressed,
    isDisabled,
    isReadOnly,
    isInvalid: isInvalid || validationState === "invalid"
  };
}
function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
  let validationState = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: state.isSelected
  });
  let { isInvalid, validationErrors, validationDetails } = validationState.displayValidation;
  let { labelProps, inputProps, isSelected, isPressed, isDisabled, isReadOnly } = $d2c8e2b0480f3f34$export$cbe85ee05b554577({
    ...props,
    isInvalid
  }, state, inputRef);
  $e93e671b31057976$export$b8473d3665f3a75a(props, validationState, inputRef);
  let { isIndeterminate, isRequired, validationBehavior = "aria" } = props;
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
  });
  let { pressProps } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled: isDisabled || isReadOnly,
    onPress() {
      let { [$e5be200c675c3b3a$export$a763b9476acd3eb]: groupValidationState } = props;
      let { commitValidation } = groupValidationState ? groupValidationState : validationState;
      commitValidation();
    }
  });
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, pressProps),
    inputProps: {
      ...inputProps,
      checked: isSelected,
      "aria-required": isRequired && validationBehavior === "aria" || void 0,
      required: isRequired && validationBehavior === "native"
    },
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
function $3017fa7ffdddec74$export$8042c6c013fd5226(props = {}) {
  let { isReadOnly } = props;
  let [isSelected, setSelected] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isSelected, props.defaultSelected || false, props.onChange);
  let [initialValue] = useState(isSelected);
  function updateSelected(value) {
    if (!isReadOnly) setSelected(value);
  }
  function toggleState() {
    if (!isReadOnly) setSelected(!isSelected);
  }
  var _props_defaultSelected;
  return {
    isSelected,
    defaultSelected: (_props_defaultSelected = props.defaultSelected) !== null && _props_defaultSelected !== void 0 ? _props_defaultSelected : initialValue,
    setSelected: updateSelected,
    toggle: toggleState
  };
}
function $fba3e38d5ca8983f$export$353b32fc6898d37d(props, state, inputRef) {
  const toggleState = $3017fa7ffdddec74$export$8042c6c013fd5226({
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isSelected: state.isSelected(props.value),
    defaultSelected: state.defaultValue.includes(props.value),
    onChange(isSelected) {
      if (isSelected) state.addValue(props.value);
      else state.removeValue(props.value);
      if (props.onChange) props.onChange(isSelected);
    }
  });
  let { name, form, descriptionId, errorMessageId, validationBehavior } = $1ae600c947479353$export$ec98120685d4f57d.get(state);
  var _props_validationBehavior;
  validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
  let { realtimeValidation } = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: toggleState.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  });
  let nativeValidation = useRef($e5be200c675c3b3a$export$dad6ae84456c676a);
  let updateValidation = () => {
    state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
  };
  useEffect(updateValidation);
  let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
  let displayValidation = validationBehavior === "native" ? state.displayValidation : combinedRealtimeValidation;
  var _props_isRequired;
  let res = $406796ff087fe49b$export$e375f10ce42261c5({
    ...props,
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isDisabled: props.isDisabled || state.isDisabled,
    name: props.name || name,
    form: props.form || form,
    isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
    validationBehavior,
    [$e5be200c675c3b3a$export$a763b9476acd3eb]: {
      realtimeValidation: combinedRealtimeValidation,
      displayValidation,
      resetValidation: state.resetValidation,
      commitValidation: state.commitValidation,
      updateValidation(v) {
        nativeValidation.current = v;
        updateValidation();
      }
    }
  }, toggleState, inputRef);
  return {
    ...res,
    inputProps: {
      ...res.inputProps,
      "aria-describedby": [
        props["aria-describedby"],
        state.isInvalid ? errorMessageId : null,
        descriptionId
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const StandaloneCheckbox = forwardRef((props, ref) => {
  const {
    className,
    focusedClassName,
    pressedClassName,
    selectedClassName,
    isSelected,
    defaultSelected,
    id,
    ...restProps
  } = props;
  const inputRef = useRef(null);
  const { focusProps, isFocusVisible } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  const toggleState = $3017fa7ffdddec74$export$8042c6c013fd5226({
    ...restProps,
    isSelected,
    defaultSelected
  });
  const { labelProps, inputProps, isPressed } = $406796ff087fe49b$export$e375f10ce42261c5(
    restProps,
    toggleState,
    inputRef
  );
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: clsx(className, {
        [selectedClassName || ""]: toggleState.isSelected,
        [pressedClassName || ""]: isPressed,
        [focusedClassName || ""]: isFocusVisible,
        [focus.focusRing]: isFocusVisible
      }),
      id,
      ...labelProps,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
            ref: ref || inputRef,
            className: helpers.srOnly
          }
        ),
        props.children
      ]
    }
  );
});
const GroupCheckbox = forwardRef((props, ref) => {
  const { className, focusedClassName, pressedClassName, selectedClassName, id, ...restProps } = props;
  const inputRef = useRef(null);
  const { focusProps, isFocusVisible } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  const groupContext = useCheckboxGroupProvider();
  const { labelProps, inputProps, isSelected, isPressed } = $fba3e38d5ca8983f$export$353b32fc6898d37d(
    restProps,
    groupContext.state,
    inputRef
  );
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: clsx(className, {
        [selectedClassName || ""]: isSelected,
        [pressedClassName || ""]: isPressed,
        [focusedClassName || ""]: isFocusVisible,
        [focus.focusRing]: isFocusVisible
      }),
      id,
      ...labelProps,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
            ref: ref || inputRef,
            className: helpers.srOnly
          }
        ),
        props.children
      ]
    }
  );
});
const CheckboxBase = forwardRef(
  (props, ref) => {
    const groupContext = useCheckboxGroupProvider();
    const isInGroup = !!groupContext;
    if (isInGroup) {
      return /* @__PURE__ */ jsx(GroupCheckbox, { ...props, ref });
    } else {
      return /* @__PURE__ */ jsx(StandaloneCheckbox, { ...props, ref });
    }
  }
);
export {
  CheckboxBase
};
